<template>
  <div
    class="tui-chat"
    :class="[isH5 ? 'tui-chat-h5' : '']"
  >
    <div
      id="tui-chat-main"
      class="tui-chat-main"
      @click="closeChatPop"
    >
      <!-- Message List -->
      <ul
        id="messageScrollList"
        ref="messageListRef"
        class="tui-message-list"
        @click="onMessageListBackgroundClick"
      >
        <li
          v-if="!isCompleted && messageList && messageList.length"
          class="message-more"
          @click="getHistoryMessageList"
        >
          {{ TUITranslateService.t("TUIChat.查看更多") }}
        </li>
        <li
          v-for="(item, index) in messageList"
          :id="'tui-' + item.ID"
          :key="item.ID"
          ref="messageElementListRef"
          class="message-li"
        >
          <MessageTimestamp
            :currTime="item.time"
            :prevTime="index > 0 ? messageList[index - 1].time : 0"
          />
          <div class="message-item">
            <MessageRevoked
              v-if="item.isRevoked"
              :isEdit="item.type === TYPES.MSG_TEXT"
              :messageItem="item"
              @messageEdit="handleEdit(item)"
            />
            <MessagePlugin
              v-else-if="isPluginMessage(item)"
              :message="deepCopy(item)"
              :blinkMessageIDList="blinkMessageIDList"
              @resendMessage="resendMessage"
              @handleToggleMessageItem="handleToggleMessageItem"
              @handleH5LongPress="handleH5LongPress"
              @heightChanged="onHeightChanged"
              @messageSent="onMessageSent"
              :enableFeedback="props.enableFeedback"
              :enableAINote="props.enableAINote"
              @like="onLike"
              @dislike="onDislike"
            />
            <div
              v-else
              :class="{
                'message-event-bind-div': true,
              }"
              @longpress="handleToggleMessageItem($event, item, true)"
              @click.prevent.right="handleToggleMessageItemForPC($event, item)"
              @touchstart="handleH5LongPress($event, item, 'touchstart')"
              @touchend="handleH5LongPress($event, item, 'touchend')"
              @mouseover="handleH5LongPress($event, item, 'touchend')"
            >
              <MessageBubble
                :content="item.getMessageContent()"
                :isAudioPlayed="Boolean(audioPlayedMapping[item.ID])"
                :blinkMessageIDList="blinkMessageIDList"
                :messageItem="JSON.parse(JSON.stringify(item))"
                :enableFeedback="props.enableFeedback"
                :enableAINote="props.enableAINote"
                @blinkMessage="blinkMessage"
                @resendMessage="resendMessage(item)"
                @like="onLike"
                @dislike="onDislike"
              >
                <template #messageElement>
                  <MessageThinking v-if="isThinkingMessage(item)"/>
                  <MessageText
                    v-else-if="item.type === TYPES.MSG_TEXT"
                    :content="item.getMessageContent()"
                    :flow="item.flow"
                  />
                  <ProgressMessage
                    v-else-if="item.type === TYPES.MSG_IMAGE"
                    :content="item.getMessageContent()"
                    :messageItem="item"
                  >
                    <MessageImage
                      :content="item.getMessageContent()"
                      :messageItem="item"
                      @previewImage="handleImagePreview"
                    />
                  </ProgressMessage>
                  <ProgressMessage
                    v-else-if="item.type === TYPES.MSG_VIDEO"
                    :content="item.getMessageContent()"
                    :messageItem="item"
                  >
                    <MessageVideo
                      :content="item.getMessageContent()"
                      :messageItem="item"
                    />
                  </ProgressMessage>
                  <MessageAudio
                    v-else-if="item.type === TYPES.MSG_AUDIO"
                    :content="item.getMessageContent()"
                    :messageItem="item"
                    @setAudioPlayed="setAudioPlayed"
                  />
                  <ProgressMessage
                    v-else-if="item.type === TYPES.MSG_FILE"
                    :content="item.getMessageContent()"
                    :messageItem="item"
                  >
                    <MessageFile
                      :content="item.getMessageContent()"
                      :messageItem="item"
                    />
                  </ProgressMessage>
                  <MessageRecord
                    v-else-if="item.type === TYPES.MSG_MERGER"
                    :renderData="item.payload"
                    :messageItem="item"
                  />
                  <MessageFace
                    v-else-if="item.type === TYPES.MSG_FACE"
                    :content="item.getMessageContent()"
                  />
                  <MessageLocation
                    v-else-if="item.type === TYPES.MSG_LOCATION"
                    :content="item.getMessageContent()"
                  />
                  <MessageCustom
                    v-else-if="item.type === TYPES.MSG_CUSTOM"
                    :content="item.getMessageContent()"
                    :messageItem="item"
                  />
                  <MessageLargeStream
                    v-else-if="item.type === TYPES.MSG_STREAM"
                    :content="shallowCopyMessage(item.payload)"
                    @heightChanged="onHeightChanged"
                  />
                </template>
              </MessageBubble>
            </div>
            <!-- message tool -->
            <MessageTool
              v-if="item.ID === toggleID"
              ref="messageToolListRef"
              :class="{
                'message-tool': true,
                'message-tool-out': item.flow === 'out',
                'message-tool-in': item.flow === 'in',
                'message-tool-bottom': isTopMessageDom,
              }"
              :messageItem="item"
            />
          </div>
        </li>
      </ul>
      <ScrollButton
        ref="scrollButtonInstanceRef"
        @scrollToLatestMessage="scrollToLatestMessage"
        @scrollNearToBottom="scrollNearToBottom"
      />
      <Dialog
        v-if="reSendDialogShow"
        class="resend-dialog"
        :show="reSendDialogShow"
        :isH5="!isPC"
        :center="true"
        :isHeaderShow="isPC"
        @submit="resendMessageConfirm()"
        @update:show="(e) => (reSendDialogShow = e)"
      >
        <p class="delDialog-title">
          {{ TUITranslateService.t("TUIChat.确认重发该消息？") }}
        </p>
      </Dialog>
      <ImagePreviewer
        v-if="showImagePreview"
        :currentImage="currentImagePreview"
        :imageList="imageMessageList"
        @close="onImagePreviewerClose"
      />
      <BottomQuickOrder
        class="bottom-quick-order"
        v-if="isNonEmptyObject(props.bottomQuickOrder) && props.showBottomQuickOrder"
        :bottomQuickOrder="props.bottomQuickOrder"
        @closeOrder="closeBottomQuickOrder"
        @sendOrder="sendBottomQuickOrder"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import vue from '../../../adapter-vue';
const { ref, nextTick, computed, onMounted, onUnmounted } = vue;
import TUIChatEngine, {
  IMessageModel,
  TUIStore,
  StoreName,
  TUITranslateService,
  TUIChatService,
} from '../../../@aidesk/uikit-engine';
import {
  outsideClick,
  getBoundingClientRect,
  getScrollInfo,
} from '@tencentcloud/universal-api';
import MessageText from './message-elements/message-text.vue';
import MessageImage from './message-elements/message-image-web.vue';
import MessageAudio from './message-elements/message-audio-web.vue';
import MessageRecord from './message-elements/message-record/index.vue';
import MessageFile from './message-elements/message-file.vue';
import MessageFace from './message-elements/message-face.vue';
import MessageCustom from './message-elements/message-custom.vue';
import MessageBubble from './message-elements/message-bubble-web.vue';
import MessageLocation from './message-elements/message-location.vue';
import MessageTimestamp from './message-elements/message-timestamp.vue';
import MessageVideo from './message-elements/message-video-web.vue';
import MessageTool from './message-tool/index-web.vue';
import MessageRevoked from './message-tool/message-revoked.vue';
import MessagePlugin from '../message-list/message-elements/message-desk/message-plugin-web.vue';
import MessageThinking from './message-elements/message-thinking.vue';
import MessageLargeStream from './message-elements/message-large-stream.vue';
import ScrollButton from './scroll-button/index.vue';
import BottomQuickOrder from './bottom-quick-order/index.vue';
import { isPluginMessage } from './message-elements/message-desk/index';
import Dialog from '../../common/Dialog/index.vue';
import ImagePreviewer from '../../common/ImagePreviewer/index-web.vue';
import ProgressMessage from '../../common/ProgressMessage/index.vue';
import { isPC, isH5 } from '../../../utils/env';
import chatStorage from '../../../utils/chatStorage';
import {
  isEnabledMessageReadReceiptGlobal,
  deepCopy,
  isNonEmptyObject,
  updateCustomStore,
  throttle,
  shallowCopyMessage
} from '../../../utils/utils';
import { isMessageInvisible, isThinkingMessage, isThinkingMessageOverTime, JSONToObject, isTransferMessageWithoutDesc } from '../../../utils/index';
import { isCustomerConversation } from '../../../index';
import { CUSTOM_MESSAGE_SRC } from '../../../constant';
import { QuickOrderModel } from '../../../interface';
import Log from '../../../utils/logger';

interface ScrollConfig {
  scrollToMessage?: IMessageModel;
  scrollToBottom?: boolean;
  scrollToOffset?: {
    top?: number;
    bottom?: number;
  };
}

interface IProps {
  bottomQuickOrder?: QuickOrderModel;
  showBottomQuickOrder: boolean;
  enableFeedback: number;
  enableAINote: number;
}
const props = withDefaults(defineProps<IProps>(), {
  showBottomQuickOrder: false,
  enableFeedback: 0,
  enableAINote: 1,
});

interface IEmits {
  (key: 'closeInputToolBar'): void;
  (key: 'handleEditor', message: IMessageModel, type: string): void;
  (key: 'closeBottomQuickOrder'): void;
  (key: 'like', type: number,  messageInfo: Object): void;
  (key: 'dislike', type: number, messageInfo: Object): void;
}

const emits = defineEmits<IEmits>();

let observer: IntersectionObserver | null = null;
const sentReceiptMessageIDSet = new Set<string>();
const messageListRef = ref<HTMLElement>();
const messageToolListRef = ref<Array<{ messageToolDom: HTMLElement }>>();
// The messageList displayed on the screen, not including messages where isDeleted is true
const messageList = ref<IMessageModel[]>();
// All messageList, including messages where isDeleted is true
const allMessageList = ref<IMessageModel[]>();
const isCompleted = ref(false);
const currentConversationID = ref('');
const currentLastMessage = ref<IMessageModel>();
const nextReqMessageID = ref();
const toggleID = ref('');
const TYPES = ref(TUIChatEngine.TYPES);
const isLongpressing = ref(false);
const messageTarget = ref<IMessageModel>();
const messageElementListRef = ref<HTMLElement[] | null>();
const targetMessageDom = ref<HTMLElement | null>();
const blinkMessageIDList = ref<string[]>([]);
const scrollButtonInstanceRef = ref<InstanceType<typeof ScrollButton>>();
const beforeHistoryGetScrollHeight = ref<number>(0);
const isTopMessageDom = ref<boolean>(false);
const audioPlayedMapping = ref<Record<string, boolean>>({});
const enableAutoScroll = ref(true);

// image preview
const showImagePreview = ref(false);
const currentImagePreview = ref<IMessageModel>();
const imageMessageList = computed(() =>
  messageList?.value?.filter((item: IMessageModel) => {
    return (
      !item.isRevoked
      && !item.hasRiskContent
      && item.type === TYPES.value.MSG_IMAGE
    );
  }),
);

// resend message dialog
const reSendDialogShow = ref(false);
const resendMessageData = ref();

onMounted(() => {
  // Retrieve the information about whether the audio has been played from localStorage
  audioPlayedMapping.value
    = chatStorage.getChatStorage('audioPlayedMapping') || {};

  TUIStore.watch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdated,
  });

  TUIStore.watch(StoreName.CHAT, {
    messageList: onMessageListUpdated,
    messageSource: onMessageSourceUpdated,
    isCompleted: isCompletedUpdated,
    newMessageList: onNewMessageList,
  });

  TUIStore.watch(StoreName.CUSTOM, {
    isShowMessagePopMenu: isShowMessagePopMenuUpdated,
  });
});

onMounted(() => {
  messageListRef.value?.addEventListener('scroll', handelScrollListScroll);
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CHAT, {
    messageList: onMessageListUpdated,
    messageSource: onMessageSourceUpdated,
    isCompleted: isCompletedUpdated,
  });

  TUIStore.unwatch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdated,
  });

  TUIStore.unwatch(StoreName.CUSTOM, {
    isShowMessagePopMenu: isShowMessagePopMenuUpdated,
  });

  messageListRef.value?.removeEventListener('scroll', handelScrollListScroll);

  if (Object.keys(audioPlayedMapping.value).length > 0) {
    // Synchronize storage about whether the audio has been played when the component is unmounted
    chatStorage.setChatStorage('audioPlayedMapping', audioPlayedMapping.value);
  }

  sentReceiptMessageIDSet.clear();
  observer?.disconnect();
  observer = null;
});

function onNewMessageList(list: IMessageModel[]) {
  list.forEach((message:IMessageModel) => {
    if (message.type === TUIChatEngine.TYPES.MSG_CUSTOM) {
      const data = JSONToObject(message.payload.data);
      const conversationID = message.conversationID;
      if (data) {
        if (data.src === CUSTOM_MESSAGE_SRC.BOT_STATUS) {
          updateCustomStore("canEndConversation", { conversationID, value: true });
          if (data.content.content === 'inBot') {
            updateCustomStore("isInHumanService", { conversationID, value: false });
          }
        } else if (data.src === CUSTOM_MESSAGE_SRC.SEAT_STATUS) {
          updateCustomStore("canEndConversation", { conversationID, value: true });
          if (data.content.command === "updateSeatStatus") {
            if (data.content.content === 'queuing') {
              updateCustomStore("isQueuing", { conversationID, value: data.content.waitingQueueLength });
            } else if (data.content.content !== 'WaitingForAgentAnswering') {
              updateCustomStore("isQueuing", { conversationID, value: -1 });
            }
            if (data.content.content === 'inSeat') {
              updateCustomStore("isInHumanService", { conversationID, value: true });
            } else if (data.content.content === 'outSeat') {
              updateCustomStore("isInHumanService", { conversationID, value: false });
            }
          }
        } else if (data.src === CUSTOM_MESSAGE_SRC.TYPING_STATE) {
          if (data.typingStatus === 1) {
            updateCustomStore("isTyping", { conversationID, value: true });
          } else {
            updateCustomStore("isTyping", { conversationID, value: false });
          }
        } else if (data.src === CUSTOM_MESSAGE_SRC.NO_SEAT_ONLINE || data.src === CUSTOM_MESSAGE_SRC.TIMEOUT || data.src === CUSTOM_MESSAGE_SRC.END) {
          updateCustomStore("canEndConversation", { conversationID, value: false });
          updateCustomStore("isQueuing", { conversationID, value: -1 });
        } else if (data.src === CUSTOM_MESSAGE_SRC.GET_SETTINGS) {
          TUIStore.update(StoreName.CUSTOM, "feedbackTags", data.content.menu);
          TUIStore.update(StoreName.CUSTOM, "queueLeavePageTimeoutEnable", data.content.queueLeavePageTimeoutEnable);
        }
      }
    }
  });
}

async function onMessageListUpdated(list: IMessageModel[]) {
  if (!isCustomerConversation(currentConversationID.value)) {
    Log.w(`Messages filtered as they are not customer service messages. currentConversationID: ${currentConversationID.value}`);
    return;
  }
  observer?.disconnect();
  const oldLastMessage = currentLastMessage.value;
  let hasEmojiReaction = false;
  allMessageList.value = list;
  
  messageList.value = list.filter((message, index) => {
    if (message.reactionList?.length && !message.isDeleted) {
      hasEmojiReaction = true;
    }

    // 判断是否结束
    if (isThinkingMessage(message)) {
      return isThinkingMessageOverTime(message);
    }
    if (isTransferMessageWithoutDesc(message)) {
      return false;
    }
    return !message.isDeleted && !isMessageInvisible(message as any);
  });
  if (!messageList.value?.length) {
    currentLastMessage.value = {};
    return;
  }
  const newLastMessage = messageList.value?.[messageList.value?.length - 1];
  if (messageTarget.value) {
    if (
      messageList.value?.findIndex(
        (message: IMessageModel) => message?.ID === messageTarget.value?.ID,
      ) >= 0
    ) {
      const tempMessage = messageTarget.value;
      messageTarget.value = undefined;
      await scrollToPosition({ scrollToMessage: tempMessage });
      await blinkMessage(tempMessage?.ID);
    }
  } else if (beforeHistoryGetScrollHeight.value) {
    await scrollToPosition({
      scrollToOffset: { bottom: beforeHistoryGetScrollHeight.value },
    });
  } else if (
    scrollButtonInstanceRef.value?.isScrollButtonVisible
    && newLastMessage?.flow === 'in'
  ) {
    return;
  } else if (
    newLastMessage?.ID
    && JSON.stringify(oldLastMessage) !== JSON.stringify(newLastMessage)
  ) {
    await scrollToPosition({ scrollToBottom: true });
  } else if (hasEmojiReaction && isCurrentListInBottomPosition()) {
    await scrollToPosition({ scrollToBottom: true });
  }
  currentLastMessage.value = Object.assign({}, newLastMessage);
  nextTick(() => bindIntersectionObserver());
}

function isCurrentListInBottomPosition() {
  return (
    messageListRef.value
    && typeof messageListRef.value.scrollTop === 'number'
    && typeof messageListRef.value.scrollHeight === 'number'
    && typeof messageListRef.value.clientHeight === 'number'
    && Math.ceil(
      messageListRef.value.scrollTop + messageListRef.value.clientHeight,
    ) >= messageListRef.value.scrollHeight
  );
}

async function scrollToPosition(config: ScrollConfig = {}): Promise<void> {
  return new Promise((resolve, reject) => {
    requestAnimationFrame(() => {
      if (!messageListRef.value) {
        reject();
      }
      const container = messageListRef.value;
      if (config.scrollToBottom && container) {
        container!.scrollTop = container!.scrollHeight;
      } else if (config.scrollToMessage) {
        const targetMessageDom = messageElementListRef.value?.find(
          (dom: HTMLElement) => dom?.id === `tui-${config.scrollToMessage?.ID}`,
        );
        if (targetMessageDom?.scrollIntoView) {
          targetMessageDom.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
        }
      } else if (config.scrollToOffset) {
        if (config.scrollToOffset?.top) {
          container!.scrollTop = config.scrollToOffset.top;
        } else if (config.scrollToOffset?.bottom) {
          container!.scrollTop = container!.scrollHeight - config.scrollToOffset.bottom;
        }
      }
      resolve();
    });
  });
}

async function onMessageSourceUpdated(message: IMessageModel) {
  // messageSource change has two cases
  // 1. messageSource change -> cache miss -> messageList change,
  // 2. messageSource change -> cache hit -> messageList not change
  // Only the second case needs to add scrollToTarget when listening here
  messageTarget.value = message;
  if (messageTarget.value) {
    if (
      messageList.value?.findIndex(
        (message: IMessageModel) => message?.ID === messageTarget.value?.ID,
      ) >= 0
    ) {
      const tempMessage = messageTarget.value;
      messageTarget.value = undefined;
      await scrollToPosition({ scrollToMessage: tempMessage });
      await blinkMessage(tempMessage?.ID);
    }
  }
}

function isCompletedUpdated(flag: boolean) {
  isCompleted.value = flag;
}

function isShowMessagePopMenuUpdated(isShow: boolean) {
  if (!isShow) {
    toggleID.value = '';
  }
}

const onCurrentConversationIDUpdated = (conversationID: string) => {
  currentConversationID.value = conversationID;
  if (!currentConversationID.value) {
    messageList.value = [];
  }
  if (Object.keys(audioPlayedMapping.value).length > 0) {
    // Synchronize storage about whether the audio has been played when converstaion switched
    chatStorage.setChatStorage('audioPlayedMapping', audioPlayedMapping.value);
  }
  preloadEmoji();
};

const preloadEmoji = () => {
  setTimeout(() => {
    let url;
    let img;
    for (let i = 0; i <= 61; i++) {
      url = `https://web.sdk.qcloud.com/im/assets/emoji-plugin/emoji_${i}@2x.png`;
      img = new Image();
      img.src = url;
    }
  }, 0);
}

const getHistoryMessageList = () => {
  TUIChatService.getMessageList().then((res: any) => {
    const { nextReqMessageID: ID } = res.data;
    nextReqMessageID.value = ID;
  });
  // After getting the historical messages, keep the scroll bar in the original position
  beforeHistoryGetScrollHeight.value = messageListRef.value?.scrollHeight;
};

const handleImagePreview = (message: IMessageModel) => {
  if (
    showImagePreview.value
    || currentImagePreview.value
    || isLongpressing.value
  ) {
    return;
  }
  showImagePreview.value = true;
  currentImagePreview.value = message;
};

const onImagePreviewerClose = () => {
  showImagePreview.value = false;
  currentImagePreview.value = null;
};

// toggle message
const handleToggleMessageItem = (
  e: any,
  message: IMessageModel,
  isLongpress = false,
) => {
  if (isLongpress) {
    isLongpressing.value = true;
  }
  toggleID.value = message.ID;
  filterTopMessageDom(e.target);
};

const handleToggleMessageItemForPC = (
  e: MouseEvent,
  message: IMessageModel,
) => {
  if (isPC) {
    toggleID.value = message.ID;
    targetMessageDom.value = messageElementListRef.value?.find(
      (dom: HTMLElement) => dom?.id === `tui-${message.ID}`,
    );
    nextTick(() => {
      const ignoreDomRefs
        = messageToolListRef.value && messageToolListRef.value[0]?.messageToolDom;
      outsideClick.listen({
        domRefs: targetMessageDom.value,
        ignoreDomRefs: ignoreDomRefs,
        handler: closeChatPop,
        button: e.button,
      });
      filterTopMessageDom(e.target);
    });
  }
};

function filterTopMessageDom(toggleMessageElement: any) {
  const chatElement = document.getElementById('tui-chat-main');
  const safeTop = 160;
  const messageElementRect = toggleMessageElement.getBoundingClientRect();
  const ChatElementRect = chatElement.getBoundingClientRect();
  isTopMessageDom.value
    = messageElementRect.top - ChatElementRect.top < safeTop ? true : false;
}

// h5 long press
let timer: number;
const handleH5LongPress = (e: any, message: IMessageModel, type: string) => {
  if (!isH5) return;
  function longPressHandler() {
    clearTimeout(timer);
    handleToggleMessageItem(e, message);
  }
  function touchStartHandler() {
    timer = setTimeout(longPressHandler, 500);
  }
  function touchEndHandler() {
    clearTimeout(timer);
  }
  switch (type) {
    case 'touchstart':
      touchStartHandler();
      break;
    case 'touchend':
      touchEndHandler();
      setTimeout(() => {
        isLongpressing.value = false;
      }, 200);
      break;
  }
};

function onHeightChanged() {
  // 如果 view more 导致了子组件派发了 heightChanged 事件，不滚动到最底部，保留原来的滚动位置
  if (beforeHistoryGetScrollHeight.value > 0) {
    return;
  }
  if (enableAutoScroll.value) {
    scrollToLatestMessage();
  }
  // scrollToLatestMessage();
}

function onMessageSent() {
  scrollToLatestMessage();
}

// re-edit message
const handleEdit = (message: IMessageModel) => {
  emits('handleEditor', message, 'reedit');
};

const resendMessage = (message: IMessageModel) => {
  reSendDialogShow.value = true;
  resendMessageData.value = message;
};

const resendMessageConfirm = () => {
  reSendDialogShow.value = !reSendDialogShow.value;
  const messageModel = resendMessageData.value;
  messageModel.resendMessage();
};

function blinkMessage(messageID: string): Promise<void> {
  return new Promise((resolve) => {
    const index = blinkMessageIDList.value.indexOf(messageID);
    if (index < 0) {
      blinkMessageIDList.value.push(messageID);
      const timer = setTimeout(() => {
        blinkMessageIDList.value.splice(
          blinkMessageIDList.value.indexOf(messageID),
          1,
        );
        clearTimeout(timer);
        resolve();
      }, 3000);
    }
  });
}

async function scrollToLatestMessage() {
  const { scrollHeight } = await getScrollInfo('#messageScrollList');
  const { height } = await getBoundingClientRect('#messageScrollList');
  if (messageListRef.value) {
    messageListRef.value.scrollTop = scrollHeight - height;
  }
  scrollButtonInstanceRef.value?.hideScrollButton();
  beforeHistoryGetScrollHeight.value = 0;
  // 滚动到底部的时候，及时检查是否要上报已读回执
  bindIntersectionObserver();
}

function scrollNearToBottom() {
  // 滚动到底部的时候，及时检查是否要上报已读回执
  bindIntersectionObserver();
}

const handelScrollListScroll = throttle(
  function (e: Event) {
    scrollButtonInstanceRef.value?.judgeScrollOverOneScreen(e);
    if (messageListRef.value) {
      const distance = messageListRef.value.scrollHeight
        - messageListRef.value.scrollTop
        - messageListRef.value.clientHeight;
      if (distance < 100) {
        enableAutoScroll.value = true;
      } else {
        enableAutoScroll.value = false;
      }
    }
  },
  150,
  { leading: true },
);

async function bindIntersectionObserver() {
  if (!messageList.value || !messageListRef.value || messageList.value.length === 0) {
    return;
  }

  if (!isEnabledMessageReadReceiptGlobal()) {
    return;
  }

  const mappingFromIDToMessage: Record<string, { msgDom: HTMLElement; msgModel: IMessageModel | undefined; }> = {};

  if (observer) {
    observer.disconnect();
  }
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const { isIntersecting, target } = entry;
      if (isIntersecting) {
        const { msgDom, msgModel } = mappingFromIDToMessage[target.id];
        if (msgModel) {
          const { readReceiptInfo, ID, payload } = msgModel;
          if (!readReceiptInfo.isPeerRead && !sentReceiptMessageIDSet.has(ID)) {
            TUIChatService.sendMessageReadReceipt([msgModel]);
            sentReceiptMessageIDSet.add(ID);
            Log.l(`Receipt sent. ID:${ID} payload:${JSON.stringify(payload)}`);
            if (observer) {
              observer.unobserve(msgDom);
            }
          }
        }
      }
    });
  }, {
    root: messageListRef.value,
    threshold: 0.3, // 超过1/4可见时触发，提高灵敏度
  });

  const arrayOfMessageLi = messageListRef.value?.querySelectorAll('.message-li');
  if (arrayOfMessageLi) {
    for (let i = 0, length = arrayOfMessageLi.length; i < length; i++) {
      const messageElement = arrayOfMessageLi[i] as HTMLElement;
      const matchingMessage = messageList.value.find((message: IMessageModel) => {
        // replace tui-
        return messageElement.id.slice(4) === message.ID;
      });
      if (matchingMessage) {
        const { needReadReceipt, readReceiptInfo, flow } = matchingMessage;
        // 收到的消息需要已读回执，但我尚未发送
        if (needReadReceipt && flow === 'in' && !readReceiptInfo.isPeerRead) {
          mappingFromIDToMessage[messageElement.id] = {
            msgDom: messageElement,
            msgModel: matchingMessage,
          };
          if (observer) {
            observer.observe(messageElement);
          }
        }
      }
    }
  }
}

function closeChatPop() {
  toggleID.value = '';
}

function onMessageListBackgroundClick() {
  emits('closeInputToolBar');
}

function setAudioPlayed(messageID: string) {
  audioPlayedMapping.value = {
    ...audioPlayedMapping.value,
    [messageID]: true,
  };
}

function closeBottomQuickOrder() {
  emits('closeBottomQuickOrder');
}

function sendBottomQuickOrder() {
  if (!props.bottomQuickOrder) {
    return;
  }
  const normalizedQuickOrder: QuickOrderModel = {
    ...props.bottomQuickOrder,
    customField: (props.bottomQuickOrder.customField || []).map(f => ({
      name: f.name ? String(f.name) : '',
      value: f.value ? String(f.value) : '',
    })),
  }
  TUIChatService.sendCustomMessage({
    to: currentConversationID.value.replace('C2C', ''),
    conversationType: 'C2C',
    payload: {
      data: JSON.stringify({
        src: CUSTOM_MESSAGE_SRC.PRODUCT_CARD,
        content: normalizedQuickOrder,
        customerServicePlugin: 0,
      }),
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  });
  closeBottomQuickOrder();
}

function onLike(type: number, messageInfo: Object) {
  emits('like', type, messageInfo);
};

function onDislike(type: number, messageInfo: Object) {
  emits('dislike', type, messageInfo);
};

defineExpose({
  scrollToLatestMessage,
});
</script>

<style lang="scss" scoped src="./style/index.scss"></style>
<style>
.row-reverse {
  flex-direction: row-reverse;
}
.bottom-quick-order {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
}
</style>
